window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
} catch (e) {
	console.error(e);
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });

import Vue from 'vue';
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate, {
  inject: true,
  fieldsBagName: 'veeFields'
});

// Import role and permission for vuejs files
import Permissions from './vues/Permissions';
Vue.mixin(Permissions);
import Roles from './vues/Roles';
Vue.mixin(Roles);


/**
 * Create global Vue event bus.
 */
window.events = new Vue();


/**
 * Make toastr available and setup.
 */
import VueToastr2 from 'vue-toastr-2'
import 'vue-toastr-2/dist/vue-toastr-2.min.css'
 
window.toastr = require('toastr')
Vue.use(VueToastr2);

import {BadgerAccordion, BadgerAccordionItem} from 'vue-badger-accordion';

Vue.component('BadgerAccordion', BadgerAccordion);
Vue.component('BadgerAccordionItem', BadgerAccordionItem);

import { BootstrapVue, BootstrapVueIcons, BCollapse } from 'bootstrap-vue';
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.component('b-collapse', BCollapse);

import Datepicker from 'vuejs-datepicker';
Vue.use(Datepicker);
Vue.component('Datepicker', Datepicker);
import * as VueGoogleMaps from 'vue2-google-maps';
Vue.use(VueGoogleMaps, {
    load: {
      key: 'AIzaSyA-4Zo7MTg9DpqXd9AayZFpulEcvFi_3B4',
      libraries: 'places,drawing,geometry,visualization'
    }
});

Vue.component('pagination', require('laravel-vue-pagination'));

// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.component('loading', Loading);

import VModal from 'vue-js-modal';
Vue.use(VModal);

import VTooltip from 'v-tooltip';
Vue.use(VTooltip);

import 'jquery-ui-dist/jquery-ui';

Vue.use(require('vue-moment'));

import 'datatables';